// extracted by mini-css-extract-plugin
export default {"createbeer":"style_createbeer__lfVCy","textblock":"style_textblock__HdK29","comment":"style_comment__WCaoM","btn1":"style_btn1__3Epnj"};